<template>
  <header>
    <a class="btn-back" @click="goBack">&lt; {{$t('header.back')}}</a>
    <router-link :to="{name: 'HomePage'}"><img src="/static/logo.png" /></router-link>
  </header>
</template>

<script>
export default {
  name: 'BaseHeader',
  methods: {
    goBack() {
      if (window.history.length > 0) {
        window.history.back();
      } else {
        this.$router.push({name: 'HomePage'});
      }
    }
  }
};
</script>

<style scoped>
  header {
    padding: 0;
    line-height: 30px;
    text-align: center;
    background-color: #ccc;
  }
  header a.btn-back {
    font-size: 16px;
    position: absolute;
    left: 10px;
    top: 10px;
  }
  header img {
    margin-top: 10px;
    width: 27px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue